<!-- VIP套餐选择 -->
<template>
  <div class="vippkg">
    <div class="pkg">
      <div class="pkg-title">
        <div class="pkg-title-name">请选择VIP套餐</div>
        <div class="pkg-title-exchange" @click="goCdkey"><span>使用兑换码</span><img src="@/assets/global/next.png"></div>
      </div>
      <div class="pkg-content" ref="pkgContent">
        <div class="pkg-content-value" :class="{'active': activeGoodsIndex == index}" v-for="(item, index) in vipGoodsData" :key="item.id" @click="selectGoods(index)">
          <p class="pkg-content-value-name">{{item.name}}</p>
          <div class="price-wrapper">
            <p class="pkg-content-value-price"><span>￥</span>{{item.priceLabel}}</p>
            <p class="price-inner line-through" v-if="item.oriPrice"><span>￥</span><span class="ori-price">{{item.oriPrice}}</span></p>
          </div>
          <p class="pkg-content-value-desc">{{item.desc}}</p>
          <div class="pkg-content-value-subscript" v-if="item.tag">{{item.tag}}</div>
          <div class="pkg-content-value-extra-icon" v-if="item.priceLabel == '68'"></div>
        </div>
      </div>

      <div class="tips">如开通会员即表示您同意<a class="tips-link" href="https://www.idaddy.cn/mobile/vip/xieyi.html">《会员服务协议》</a></div> 
    </div>
  </div>
</template>

<script>
import { getVipGoodsList } from '@/api/goods'
import { cloneDeep } from 'lodash'

export default {
  name: 'VipPkg',
  props: {
    
  },
  data() {
    return {
      vipGoodsData: [],
      activeGoodsIndex: 0,
    }
  },
  async created() {
    await this.getVipGoodsListData()
  },
  mounted() {
    
  },
  methods: {
    async getVipGoodsListData() {
      try {
        let { list } = await getVipGoodsList()
        let vipGoodsData = []
        list.forEach(goods => {
          if (goods.good_id == '9003') {
            return
          }
          vipGoodsData.push({
            id: goods.good_id,
            type: goods.obj_type,
            name: goods.good_name,
            desc: goods.good_desc,
            content: goods.good_content,
            price: goods.good_price,
            oriPrice: this.genOriginPrice(goods.good_name),
            priceLabel: goods.good_price_label,
            tag: goods.tag,
          })
        })
        this.$emit('goodsSelected', vipGoodsData[0])
        this.vipGoodsData = vipGoodsData
      } catch (e) {
        console.log(e)
      }
    },

    selectGoods(index) {
      this.activeGoodsIndex = index
      this.$emit('goodsSelected', this.vipGoodsData[index])
    },
    // hack生成原价（1个月vip原价40元）
    genOriginPrice(goodsName) {
      let monthMatch = goodsName.match(/(\d+)个月/) && goodsName.match(/(\d+)个月/)[1]
      let rate = 40
      let price = 0
      if (monthMatch && (monthMatch != 1)) {
        price = monthMatch * rate
      } else if (goodsName.match(/半年/)) {
        price = 6 * rate
      } else if (goodsName.match(/一年/) || goodsName.match(/1年/)) {
        price = 365
      } else if (goodsName.match(/两年/) || goodsName.match(/2年/)) {
        price = 730
      }
      return price
    },
    goCdkey() {
      this.$router.push('cdkey')
    }
  }
}
</script>

<style lang="less" scoped>
  .pkg {
    width: 6.7rem;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fff;
    user-select: none;
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-name {
        font-size: .4rem;
        font-weight: 700;
        // color: #42343C;
        color: #604038;
      }
      &-exchange {
        font-weight: 700;
        display: flex;
        align-items: center;
        span {
          font-size: .28rem;
          color: #FEBE0C;
        }
        img {
          width: .16rem;
          height: .32rem;
        }
      }
    }
    &-content {
      margin-top: .3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      &-value {
        margin-bottom: .18rem;
        width: 3.26rem;
        // height: 1.2rem;
        padding: .32rem 0 .36rem 0;
        background: #fff;
        border: .02rem solid #E2E2E4;
        border-radius: .06rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .icon-chaozhi {
          width: .94rem;
          height: .36rem;
          background: url(/img/vip/10.7/icon-chaozhi.png) no-repeat;
          background-size: cover;
          position: absolute;
          top: -.1rem;
          right: -.1rem;
        }
        &-name {
          margin-bottom: .08rem;
          font-size: .34rem;
          font-weight: 700;
          color: #A0A0A6;
          letter-spacing: 0;
        }
        &-price {
          font-size: .7rem;
          color: #FEBE0C;
          letter-spacing: 0;
          font-weight: 700;
          letter-spacing: -1px;
          span {
            font-size: .34rem;
            color: #FEBE0C;
            letter-spacing: 0;
          }
        }
        &-desc {
          height: .4rem;
          line-height: .4rem;
          font-size: .28rem;
          color: #A0A0A6;
          letter-spacing: 0;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        &-subscript {
          width: 1.08rem;
          height: .36rem;
          line-height: .36rem;
          color: #fff;
          font-size: .2rem;
          font-weight: 700;
          text-align: center;
          position: absolute;
          top: -.1rem;
          left: -.1rem;
          background: url('~@/assets/global/sub-brown.png') no-repeat;
          background-size: 100% 100%;
        }
        &-extra-icon {
          display: block;
          position: absolute;
          top: -.1rem;
          right: -.1rem;
          width: .94rem;
          height: .36rem;
          background: url('~@/assets/buyvip/icon-chaozhi.png') no-repeat;
          background-size: cover;
          background-position: center;
        }
      }
    }
    &-desc {
      margin-top: .24rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: .56rem;
        height: .56rem;
      }
      p {
        margin-left: .16rem;
        color: #604038;
        letter-spacing: 0;
        font-size: .28rem;
        font-weight: 700;
      }
    }
    &-btn {
      height: 1.12rem;
      line-height: 1.12rem;
      margin: 0 auto;
      margin-top: .48rem;
      font-size: .34rem;
      font-weight: 700;
      color: #604038;
      text-align: center;
      // 背景渐变色
      background: linear-gradient(to right, #FEDC42 , #FEB800);
      box-shadow: 0 .04rem .16rem 0 rgba(254,184,0,0.32);
      border-radius: .12rem;
    }
  }
  .price-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: .08rem;
  }
  .price-inner {
    font-size: .28rem;
    color: #604038;
    letter-spacing: 0;
    margin-left: .16rem;
    padding-bottom: .16rem;
  }
  .line-through {
    text-decoration: line-through;
  }
  // 被选中的套餐的样式
  .active {
    background: #FEF8E4;
    border: .02rem solid #FEBE0C;
    border-radius: .06rem;
    .pkg-content-value-name {
      color: #604038;
    }
    .pkg-content-value-desc {
      color: #FEBE0C;
      font-weight: bold;
    }
  }
  .tips {
    margin-top: .2rem;
    font-size: .28rem;
    color: #a0a0a6;
    &-link {
      color: #75a8fa;
      text-decoration: none;
    }
  }
</style>
